import { match } from 'ts-pattern';

import { Text } from '~/domains/design-system/Text';

import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';
import { FieldMeta } from '../common/FieldMeta';

import { useNoteStyles } from './Note.styles';

export type NoteType = BaseField & {
  type: 'Note';
  mode?: 'accordion' | 'text';
};

function NoteElement({ field, errors, isTouched }: StaticFieldProps<NoteType>) {
  const { classes } = useNoteStyles();
  const mode = field.mode ?? 'text';

  return match(mode)
    .with('accordion', () => (
      <div className={classes.accordionContainer}>
        <Text variant="body-large" fw={400} ta="center" c="gray2.4">
          {field.description}
        </Text>
      </div>
    ))
    .with('text', () => (
      <div>
        <FieldMeta field={field} errors={errors} isTouched={isTouched} />
      </div>
    ))
    .exhaustive();
}

const Descriptor: FieldDescriptor<NoteType> = {
  FieldComponent: NoteElement,
  name: 'Note',
};

export default Descriptor;
